import { render, staticRenderFns } from "./AddNewCategoryButton.vue?vue&type=template&id=7d0ed302&"
import script from "./AddNewCategoryButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AddNewCategoryButton.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports